import { render, staticRenderFns } from "./sopHistory.vue?vue&type=template&id=2e605ab6"
import script from "./sopHistory.vue?vue&type=script&lang=js"
export * from "./sopHistory.vue?vue&type=script&lang=js"
import style0 from "./sopHistory.vue?vue&type=style&index=0&id=2e605ab6&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports